<template>
    <div>
        <Head :title="`${form.keyword}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/blocker-keywords">Blocker Keywords</Link>
                <span class="text-indigo-400 font-medium">/</span>
                {{ form.keyword }}
            </h1>
        </div>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.keyword" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Keyword"/>
                                
                    <select-input v-model="form.locale" :error="form.errors.locales"  class="pb-8 pr-6 w-full lg:w-1/2" label="Language">
                        <option value="en">EN</option>
                        <option value="de">DE</option>
                    </select-input>
                    <select-input v-model="form.response" :error="form.errors.response"  class="pb-8 pr-6 w-full lg:w-1/2" label="Auto Response Message" v-if="responses">
                    <option :value="null"></option>  
                    <option :value="response.id" v-for="response in responses">{{ response.name }}</option>
                    </select-input>
                    <multiple-select-input v-model="form.tags" :error="form.errors.tags"  class="pb-8 pr-6 w-full lg:w-1/2" label="Tags">
                        <option :key="tag.id" :value="tag.id" v-for="tag in tags">{{ tag.name }}</option>
                    </multiple-select-input>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Update Keyword
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import MultipleSelectInput from '@/Shared/MultipleSelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import throttle from 'lodash/throttle'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        MultipleSelectInput,
        TextInput,
    },
    layout: Layout,
    props: {
        keyword: Object,
        tags: Array,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                keyword: this.keyword.keyword,
                locale: this.keyword.locale,
                tags: this.keyword.tags,
                response: this.keyword.response_id
            }),
            responses: []
        }
    },
    watch: {
        'form.locale': {
        deep: true,
        handler: throttle(function (locale) {
            this.loadResponseOptions(locale);
        }, 150),
        },
    },
    created() {
        this.loadResponseOptions(this.keyword.locale)
    },
    methods: {
        update() {
            this.form.post(`/blocker-keywords/${this.keyword.id}`)
        },
        loadResponseOptions(locale) {
            this.responses = [];
            axios.get('/blocker-keyword-response/option-list?locale='+locale).then(result => {
                if(result.data.success) {
                    this.responses = result.data.data;
                }
            })
        }
    },
}
</script>
